import React from 'react';

const BigIconPanel = ({ children }) => (
    <div className="big-icon-panel">{children}</div>
);

BigIconPanel.propTypes = {

};

export default BigIconPanel;
